import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AnnotationData, AnnotationService } from './annotation.service';

@Component({
  selector: 'app-annotation-container',
  imports: [CommonModule],
  templateUrl: './annotation-container.component.html',
  styleUrls: ['./annotation-container.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnnotationContainerComponent {
  protected annotationService = inject(AnnotationService);

  onAnnotationTitleClick(annotation: AnnotationData): void {
    this.annotationService.toggleAnnotationDescription(annotation.uuid);
  }
}
